export enum InspectionDeploymentRowStatus {
  New = 1,
  InProgress = 2,
  Deployed = 3,
  Error = 4,
}

export enum InspectionDeploymentStatus {
  AwaitingStart = 1,
  InProgress = 2,
  Deployed = 3,
}
